/// <amd-module name="DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/Build/RestClient/Build" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   distributedtask\web\extensions\vss-distributedtask-web\dt-security\tfs.build.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as Build from "DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/Build/Contracts/Build";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IBuildRestClient extends IVssRestClient {
    /**
     * Gets a list of definitions.
     * 
     * @param project - Project ID or project name
     * @param name - If specified, filters to definitions whose names match this pattern.
     * @param repositoryId - A repository ID. If specified, filters to definitions that use this repository.
     * @param repositoryType - If specified, filters to definitions that have a repository of this type.
     * @param queryOrder - Indicates the order in which definitions should be returned.
     * @param top - The maximum number of definitions to return.
     * @param continuationToken - A continuation token, returned by a previous call to this method, that can be used to return the next set of definitions.
     * @param minMetricsTime - If specified, indicates the date from which metrics should be included.
     * @param definitionIds - A comma-delimited list that specifies the IDs of definitions to retrieve.
     * @param path - If specified, filters to definitions under this folder.
     * @param builtAfter - If specified, filters to definitions that have builds after this date.
     * @param notBuiltAfter - If specified, filters to definitions that do not have builds after this date.
     * @param includeAllProperties - Indicates whether the full definitions should be returned. By default, shallow representations of the definitions are returned.
     * @param includeLatestBuilds - Indicates whether to return the latest and latest completed builds for this definition.
     * @param taskIdFilter - If specified, filters to definitions that use the specified task.
     * @param processType - If specified, filters to definitions with the given process type.
     * @param yamlFilename - If specified, filters to YAML definitions that match the given filename. To use this filter includeAllProperties should be set to true
     */
    getDefinitions(project: string, name?: string, repositoryId?: string, repositoryType?: string, queryOrder?: Build.DefinitionQueryOrder, top?: number, continuationToken?: string, minMetricsTime?: Date, definitionIds?: number[], path?: string, builtAfter?: Date, notBuiltAfter?: Date, includeAllProperties?: boolean, includeLatestBuilds?: boolean, taskIdFilter?: string, processType?: number, yamlFilename?: string): Promise<VS_Services.PagedList<Build.BuildDefinitionReference>>;
}

class BuildRestClient extends RestClientBase implements IBuildRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Gets a list of definitions.
     * 
     * @param project - Project ID or project name
     * @param name - If specified, filters to definitions whose names match this pattern.
     * @param repositoryId - A repository ID. If specified, filters to definitions that use this repository.
     * @param repositoryType - If specified, filters to definitions that have a repository of this type.
     * @param queryOrder - Indicates the order in which definitions should be returned.
     * @param top - The maximum number of definitions to return.
     * @param continuationToken - A continuation token, returned by a previous call to this method, that can be used to return the next set of definitions.
     * @param minMetricsTime - If specified, indicates the date from which metrics should be included.
     * @param definitionIds - A comma-delimited list that specifies the IDs of definitions to retrieve.
     * @param path - If specified, filters to definitions under this folder.
     * @param builtAfter - If specified, filters to definitions that have builds after this date.
     * @param notBuiltAfter - If specified, filters to definitions that do not have builds after this date.
     * @param includeAllProperties - Indicates whether the full definitions should be returned. By default, shallow representations of the definitions are returned.
     * @param includeLatestBuilds - Indicates whether to return the latest and latest completed builds for this definition.
     * @param taskIdFilter - If specified, filters to definitions that use the specified task.
     * @param processType - If specified, filters to definitions with the given process type.
     * @param yamlFilename - If specified, filters to YAML definitions that match the given filename. To use this filter includeAllProperties should be set to true
     */
    public async getDefinitions(
        project: string,
        name?: string,
        repositoryId?: string,
        repositoryType?: string,
        queryOrder?: Build.DefinitionQueryOrder,
        top?: number,
        continuationToken?: string,
        minMetricsTime?: Date,
        definitionIds?: number[],
        path?: string,
        builtAfter?: Date,
        notBuiltAfter?: Date,
        includeAllProperties?: boolean,
        includeLatestBuilds?: boolean,
        taskIdFilter?: string,
        processType?: number,
        yamlFilename?: string
        ): Promise<VS_Services.PagedList<Build.BuildDefinitionReference>> {

        const queryValues: any = {
            name: name,
            repositoryId: repositoryId,
            repositoryType: repositoryType,
            queryOrder: queryOrder,
            '$top': top,
            continuationToken: continuationToken,
            minMetricsTime: minMetricsTime,
            definitionIds: definitionIds && definitionIds.join(","),
            path: path,
            builtAfter: builtAfter,
            notBuiltAfter: notBuiltAfter,
            includeAllProperties: includeAllProperties,
            includeLatestBuilds: includeLatestBuilds,
            taskIdFilter: taskIdFilter,
            processType: processType,
            yamlFilename: yamlFilename
        };

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.7",
            routeTemplate: "{project}/_apis/build/definitions/{definitionId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<Build.BuildDefinitionReference>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

}

export const BuildClientName = "dt-security.build.client.IBuildRestClient";

export function getBuildClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IBuildRestClient {
    return pageContext.getRestClient<IBuildRestClient>(BuildClientName, options);
}

RestClients.add(BuildClientName, { 
    factory: BuildRestClient,
    options: {
        resourceAreaId: "965220d5-5bb9-42cf-8d67-9b146df2a5a4",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
